export const logos = [
  {
    key: "Apple",
    fields: [
      "email",
      "order_number e.g.#W0000000000",
      "order_date e.g.#Aug#01,2023",
      "delivery_date e.g.#Mon,Aug#01",
      "image_link",
      "item",
      "full_name",
      "last_2_phone_number",
      "street",
      "city",
      "zip",
      "country",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$0.00",
      "tax e.g.#$0.00",
      "total e.g.#$100.00",
    ],
  },
  {
    key: "Balenciaga",
    fields: [
      "email",
      "image_link",
      "item",
      "color",
      "size",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$0.00",
      "total e.g.#$100.00",
      "full_name",
      "street",
      "city",
      "zip",
    ],
  },
  {
    key: "DIOR",
    fields: [
      "email",
      "order_number e.g.#DL00000000",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "image_link",
      "order_date e.g.#01/01/2023",
      "item",
      "size",
      "subtotal e.g.#100.00#$",
      "shipping e.g.#10.00#$",
      "taxes e.g.#50.00#$",
      "total e.g.#160.00#$",
    ],
  },
  {
    key: "END.",
    fields: [
      "email",
      "order_number e.g.#1000000000",
      "image_link",
      "item",
      "color",
      "size",
      "subtotal e.g.#$100.00",
      "discount e.g.#$0.00",
      "shipping e.g.#$0.00",
      "tax e.g.#$50.00",
      "total e.g.#$160.00",
      "full_name",
      "street",
      "city",
      "zip",
      "eta e.g.#Mon#1#Jan",
    ],
  },
  {
    key: "Farfetch",
    fields: [
      "email",
      "language",
      "order_number e.g.#1ABC2D",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "image_link",
      "estimated_delivery_from e.g.#01/01/2023",
      "estimated_delivery_to e.g.#01/01/2023",
      "shipped_from e.g.#Italy",
      "brand",
      "item",
      "subtotal e.g.#100.00#$",
      "shipping e.g.#10.00#$",
      "taxes e.g.#50.00#$",
      "credit e.g.#0.00#$",
      "promotions e.g.#0.00#$",
      "total e.g.#160.00#$",
    ],
  },
  {
    key: "Hermès",
    fields: [
      "email",
      "order_date e.g.#January#1,2023",
      "order_number e.g.#900000000",
      "image_link",
      "item",
      "color",
      "size",
      "reference_number",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$0.00",
      "total e.g.#$100.00",
      "full_name",
      "street",
      "city",
      "zip",
    ],
  },
  {
    key: "GOAT",
    fields: [
      "email",
      "order_number e.g.#400000000",
      "image_link",
      "style_id",
      "item_name",
      "size",
      "brand",
      "shoe_condition",
      "box_condition",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$10.00",
      "tax e.g.#$50.00",
      "goat_credit e.g.#$0.00",
      "total e.g.#$160.00",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
    ],
  },
  {
    key: "Grailed",
    fields: [
      "email",
      "image_link",
      "brand",
      "item",
      "size",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "subtotal e.g.#$100.00",
      "taxes e.g.#$50.00",
      "total e.g.#$150.00",
      "seller_location e.g.#United#States",
      "seller_profile_image_link",
    ],
  },
  {
    key: "Louis Vuitton",
    fields: [
      "email",
      "order_number e.g.#nx000000000",
      "image_link",
      "item",
      "style_id",
      "color",
      "subtotal e.g.#100.00#$",
      "shipping e.g.#10.00#$",
      "total e.g.#110.00#$",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
    ],
  },
  {
    key: "Moncler",
    fields: [
      "email",
      "order_number e.g.#100000123456",
      "order_date e.g.#1#January#2023",
      "image_link",
      "item",
      "size",
      "color",
      "eta e.g.#1#January#2023",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$10.00",
      "total e.g.#$110.00",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "payment_method e.g.#Paypal",
    ],
  },
  {
    key: "SNKRS",
    fields: [
      "email",
      "full_name",
      "street",
      "city",
      "zip",
      "order_number e.g.#C01000000000",
      "order_date e.g.#01/01/2023",
      "image_link",
      "item_name",
      "style_id",
      "size e.g.#M#10#/#W#11.5",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$10.00",
      "tax e.g.#$50.00",
      "total e.g.#$160.00",
    ],
  },
  {
    key: "SSENSE",
    fields: [
      "email",
      "order_number e.g.#990000000000",
      "order_date e.g.#January#1#2023",
      "payment_method e.g.#Visa#412345******1234",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "image_link",
      "item",
      "style_id",
      "size",
      "subtotal e.g.#$100.00#USD",
      "shipping e.g.#$10.00#USD",
      "taxes e.g.#$50.00#USD",
      "total e.g.#$160.00#USD",
    ],
  },
  {
    key: "Stadium Goods",
    fields: [
      "email",
      "order_number e.g.#A1BCDE",
      "image_link",
      "item",
      "style_id",
      "subtotal e.g.#100.00#$",
      "shipping e.g.#10.00#$",
      "discount e.g.#0.00#$",
      "taxes e.g.#50.00#$",
      "total e.g.#160.00#$",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
    ],
  },
  {
    key: "StockX",
    fields: [
      "email",
      "delivery_date",
      "item_name",
      "item_link e.g.#stockx.com/",
      "image_link",
      "style_id",
      "size e.g.#U.S.Men's#Size:#10",
      "size_in_brackets e.g.#(Size#10)",
      "order_number e.g.#40000000-40000000",
      "purchase_price e.g.#$1,000",
      "tax_options",
      "amount e.g.#$50",
      "processing_fee e.g.#$100",
      "shipping e.g.#$25",
      "total e.g.#$1,125",
    ],
  },
  {
    key: "Trapstar",
    fields: [
      "email",
      "order_number e.g.#000000",
      "image_link",
      "item",
      "size",
      "color",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$10.00",
      "taxes e.g.#50.00",
      "total e.g.#$160.00#USD",
      "full_name",
      "street",
      "city",
      "zip",
      "country",
      "last_4_credit_card e.g.#1234",
    ],
  },
  {
    key: "Nike",
    fields: [
      "email",
      "full_name",
      "street",
      "city",
      "zip",
      "order_number e.g.#C01000000000",
      "order_date e.g.#01/01/2023",
      "delivery_date e.g.#01/01/2023",
      "image_link",
      "item_name",
      "size e.g.#M#10#/#W#11.5",
      "last_4_credit_card e.g.#1234",
      "subtotal e.g.#$100.00",
      "shipping e.g.#$10.00",
      "total e.g.#$160.00",
    ],
  },
];
